import { onICalendarTemplateActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { ICalendarTemplateActivityCard } from "./ICalendarTemplateActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  iCalendarTemplateId: number
  config: server.dto.ActivityPanelConfig
}

export const ICalendarTemplateActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  return <ActivityPanel<server.dto.ICalendarTemplateActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.ICalendarTemplate.ListActivity({ itemId: props.iCalendarTemplateId, page, perPage })}
    renderActivity={(activity => <ICalendarTemplateActivityCard key={activity.activityId} activity={activity} />)}
    onActivityRegisterFn={onICalendarTemplateActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.iCalendarTemplateId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}